import isServer from './isServer'

const getGlobals = () => (isServer ? process.env : window.__GLOBALS__) // eslint-disable-line

export default getGlobals
